import { render, staticRenderFns } from "./base-autocomplete.vue?vue&type=template&id=aa3e3864"
import script from "./base-autocomplete.ts?vue&type=script&lang=ts&external"
export * from "./base-autocomplete.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa3e3864')) {
      api.createRecord('aa3e3864', component.options)
    } else {
      api.reload('aa3e3864', component.options)
    }
    module.hot.accept("./base-autocomplete.vue?vue&type=template&id=aa3e3864", function () {
      api.rerender('aa3e3864', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/vuetify/Autocomplete/base-autocomplete.vue"
export default component.exports